import VideoPoster from "./components/VideoPoster.js";
import VideoSound from "./components/VideoSound.js";
import {lazyHandler} from "./lazy/lazyHandler.js";
import {tools} from "./tools.js";
import Masonry from "masonry-layout/masonry.js";
import AnchorWC from "./overlay/AnchorWC.js";
import AnchorableCollapsible from "./collapsible/AnchorableCollapsible";
import Collapsible from "./collapsible/Collapsible";
import CollapsibleOdaorg from "./collapsible/CollapsibleOdaorg";
import Splide from "@splidejs/splide";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import SearchBar from "./components/SearchBar.js";
import SearchResults from "./components/SearchResults.js";

customElements.define('web-anchor', AnchorWC, {extends: "a"});

const app = {
    init() {
        document.documentElement.classList.remove('no-js');
        window.sukoa = window.sukoa || {};
        sukoa.dcmadr = function(encoded) {
            let decoded = '';
            for (let i = 0; i < encoded.length; i += 3) {
                let charCode = parseInt(encoded.substring(i, i + 3), 10);
                decoded += String.fromCharCode(charCode);
            }
            window.location.href = decoded;
        };
        this.setVH()
        this.initPageFadeIn();
        this.initNavHoverListeners();
        this.initCourseList();
        this.initLazy();
        this.initMasonryGrid();
        this.colorCheck();
        this.scrollTop();
        this.initNavigation();
        this.initSideNavigation();
        this.initCollapsibles();
        this.initOdaorgCollapsibles();
        this.initNewsSlider();
        this.initDefaultSlider();
        this.initMobileMenu();
        this.initVideoSound();
        this.initNumberedTextBoxes();
        this.initDownloadAll();
        this.initPageFadeOut();
        this.initSearch();
    },

    setVH() {
        window.addEventListener('resize', this.setViewportHeight);
        window.addEventListener('load', this.setViewportHeight);
        this.setViewportHeight();
    },

    setViewportHeight() {
        let vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', `${vh}px`);
    },

    initPageFadeIn() {
        let timeErased = false
        let loaded = false
        const pageTransitionElement = document.querySelector('.page-transition')
        if (pageTransitionElement) {

            const color = sessionStorage.getItem("color")
            if (color !== '') {
                pageTransitionElement.classList.add(color)
            } else {
                pageTransitionElement.classList.add(pageTransitionElement.dataset.color)
            }
            setTimeout(() => {
                timeErased = true
                if (loaded) {
                    pageTransitionElement.style.opacity = 0;
                }
            },300)
            window.addEventListener('load', () => {
                loaded = true
                if (timeErased) {
                    pageTransitionElement.style.opacity = 0;
                }
            })
            window.addEventListener('pageshow', (event) => {
                if (event.persisted) {
                    loaded = true
                    if (timeErased) {
                        setTimeout(() => {
                            pageTransitionElement.style.opacity = 0;
                        }, 300)
                    }
                }
            });
        }
    },

    initNavHoverListeners() {
        const header = document.querySelector('header')
        header.querySelectorAll('#main-nav .with-subnav').forEach((navElement) => {
            navElement.addEventListener('mouseenter', () => {
                header.style.backgroundColor = 'white';
            })
            navElement.addEventListener('mouseleave', () => {
                header.style.backgroundColor = '';
            })
        })
    },

    initCourseList() {
        document.querySelectorAll('.courseList').forEach((courseList) => {
            courseList.querySelectorAll('tr, .course').forEach((tr) => {
                if (tr.dataset.url != null) {
                    tr.addEventListener('click', () => {
                        const baseUrl = tr.dataset.url
                        window.open(baseUrl, '_self')
                    })
                }
            })
        })
    },

    initLazy() {
        lazyHandler();
    },

    initVideoSound() {
        document.querySelectorAll('.video-sound-toggle').forEach(el => {
            new VideoSound(el);
        });
    },

    initMobileMenu() {
        const menuToggle = document.getElementById('mobile_menu_toggle');
        const mobileMenu = document.getElementById('mobile_menu');
        if (!menuToggle || !mobileMenu) return;

        menuToggle.addEventListener('click', () => {
            const isActive = menuToggle.classList.contains('active');

            menuToggle.classList.toggle('active');
            mobileMenu.classList.toggle('active');

            // Prevent body scroll when menu is open
            document.documentElement.style.overflow = isActive ? '' : 'hidden';
        });

        // Close menu when clicking outside
        document.addEventListener('click', (e) => {
            if (mobileMenu.classList.contains('active') &&
                !mobileMenu.contains(e.target) &&
                !menuToggle.contains(e.target)) {
                menuToggle.classList.remove('active');
                mobileMenu.classList.remove('active');
                document.body.style.overflow = '';
            }
        });

        const collapsibles = mobileMenu.querySelectorAll('ul.nav > li.with-subnav');
        const initCollapsibleFn = wrapper => {
            const btn = wrapper.querySelector('.collapsible-icon');
            const btns = [btn];
            const collapsibleElt = wrapper.querySelector('.sub-nav');
            const collapsibleArea = wrapper.querySelector('ul.subnav');

            if (btns && collapsibleElt && collapsibleArea) {
                new Collapsible(wrapper.textContent.trim(), wrapper, btns, collapsibleElt, collapsibleArea);
            }
        }
        tools.each(collapsibles, initCollapsibleFn)

    },



    initNewsSlider() {
        const navWrap = document.querySelector('.slider-counter-nav')
        if (navWrap) {
            const splide = new Splide('.splide', {
                type       : 'slide',
                perPage    : 1,
                autoplay   : true,
                pagination : false, // Disable default pagination
                arrows     : false, // Disable default arrows
                lazyLoad: 'nearby'
            }).mount()

            const prev = navWrap.querySelector('.prev')
            const next = navWrap.querySelector('.next')
            const counter = navWrap.querySelector('.slider-counter')
            const counterCurrent = counter.querySelector('.current')
            const counterTotal = counter.querySelector('.total')
            const totalSlides = splide.length

            prev.addEventListener('click', () => {
                splide.go('<')
            });

            next.addEventListener('click', () => {
                splide.go('>')
            });

            // Update counter on slide change
            // splide.on('move', (newIndex) => {
            //     counterCurrent.textContent = `${newIndex + 1}`
            // });

            // Function to update button states
            const updateButtonStates = () => {
                const currentIndex = splide.index;
                const totalSlides = splide.length;

                counterCurrent.textContent = `${currentIndex + 1}`

                // Disable previous button if at the start
                if (currentIndex === 0) {
                    prev.classList.add('disabled');
                } else {
                    prev.classList.remove('disabled');
                }

                // Disable next button if at the end
                if (currentIndex === totalSlides - 1) {
                    next.classList.add('disabled');
                } else {
                    next.classList.remove('disabled');
                }
            }

            // Initial button state update
            updateButtonStates();

            // Update button states on slide change
            splide.on('move', updateButtonStates);

            // Initialize counter on load
            counterCurrent.textContent = `1`
            counterTotal.textContent = `${totalSlides}`
            if (totalSlides > 0) {
                navWrap.classList.remove('hide')
            }
        }
    },

    initNavigation() {
        const mainNav = document.getElementById("main-nav");
        const headerContainer = document.getElementById("header_container");
        if (mainNav && headerContainer) {

            const initNavPosition = () => {
                let contentWidth = headerContainer.offsetWidth;
                let navWidth = mainNav.offsetWidth;
                let subNavLeft = contentWidth - navWidth;

                document.body.style.setProperty('--nav-left-position', `${subNavLeft}px`);
                document.body.style.setProperty('--header-height', `${document.querySelector('header').offsetHeight}px`);
            }

            setTimeout(initNavPosition, 100)

            window.addEventListener("resize", e => {
                initNavPosition();
            })
        }
    },

    initSideNavigation() {
        const sideNav = document.getElementById("side_nav");
        if (sideNav) {

            const collapsibles = sideNav.querySelectorAll('ul.nav > li.with-subnav');

            const initCollapsibleFn = wrapper => {
                const btn = wrapper.querySelector('.collapsible-icon');
                const btns = [btn];
                const collapsibleElt = wrapper.querySelector('.sub-nav');
                const collapsibleArea = wrapper.querySelector('ul.subnav');

                if (btns && collapsibleElt && collapsibleArea) {
                    new Collapsible(wrapper.textContent.trim(), wrapper, btns, collapsibleElt, collapsibleArea);
                }
            }

            tools.each(collapsibles, initCollapsibleFn)
        }
    },

    initSearch() {
        const headerContainerEl = document.getElementById("header_container")

        // Handle search bar
        if (headerContainerEl) {
            new SearchBar(headerContainerEl)
        }
        // Handle search results
        const searchResultsEl = document.getElementById("search_results")
        if (searchResultsEl) {
            new SearchResults(searchResultsEl)
        }
    },

    videos() {
        const videoWrappers = document.querySelectorAll('.video-embed.poster');

        if (videoWrappers) {
            videoWrappers.forEach(video => new VideoPoster(video));
        }

    },

    colorCheck() {
        function isColorDark(rgbaColor) {
            const match = rgbaColor.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
            if (!match) {
                throw new Error('Invalid RGBA color format. Expected "rgba(r, g, b, a)" or "rgb(r, g, b)".');
            }

            const [_, r, g, b, a] = match.map((value, index) => (index === 0 ? value : parseFloat(value)));

            if (a !== undefined && a === 0) {
                return false; // Fully transparent is "light" by definition
            }

            const brightness = (r * 299 + g * 587 + b * 114) / 1000;
            return brightness < 128; // Threshold: 128 (dark vs. light)

        }

        function getHoverColor(element, property = 'backgroundColor') {

            const mouseOverHandler = () => {
                // Get computed style while the element is being hovered
                let hoverColor = window.getComputedStyle(element)[property];
                //console.log(`${property} during hover:`, hoverColor);
                if (isColorDark(hoverColor)) {
                    element.classList.add('txt-hover-white');
                }
                element.removeEventListener('mouseover', mouseOverHandler); // Cleanup
            };

            element.addEventListener('mouseover', mouseOverHandler);

        }

        tools.each(document.querySelectorAll('.bg-color'), bgColor => {
            const color = window.getComputedStyle(bgColor).backgroundColor;
            if (isColorDark(color)) {
                bgColor.classList.add('txt-white');
            }
        })

        tools.each(document.querySelectorAll('.bg-color-hover'), bgColor => {
            getHoverColor(bgColor, 'backgroundColor');
        })

    },

    initCollapsibles(selector) {
        const collapsibles = document.querySelectorAll('.collapsible-component');

        const initCollapsibleFn = wrapper => {
            const btns = wrapper.querySelectorAll('button.colbtn');
            const collapsibleElt = wrapper.querySelector('.collapsible-wrapper');
            const collapsibleArea = wrapper.querySelector('.collapsible-area');

            if (btns && collapsibleElt && collapsibleArea) {
                if (wrapper.classList.contains('anchorable')) {
                    new AnchorableCollapsible(wrapper.getAttribute('data-name').trim(), wrapper, btns, collapsibleElt, collapsibleArea);
                } else {
                    new Collapsible(wrapper.getAttribute('data-name').trim(), wrapper, btns, collapsibleElt, collapsibleArea);
                }
            }
        }

        tools.each(collapsibles, initCollapsibleFn)
    },

    initOdaorgCollapsibles() {
        const collapsibles = document.querySelectorAll('.collapsible-odaorg-component');

        const initCollapsibleFn = wrapper => {
            new CollapsibleOdaorg(wrapper);
        }

        tools.each(collapsibles, initCollapsibleFn)
        this.initCollapsibles('.sub-collapsible-odaorg')
    },

    scrollTop() {
        const scrollTop = document.getElementById('scroll_top');
        if (scrollTop) {
            scrollTop.addEventListener('click', e => {
                tools.scrollTo(window, 0, 800);
            })

        }
    },

    initMasonryGrid() {
        const masonryGrid = document.querySelectorAll('.masonry-grid');
        if (masonryGrid) {
            masonryGrid.forEach(grid => {
                let msnry = new Masonry(grid, {
                    itemSelector: '.grid-item',
                    columnWidth: '.grid-item',
                    percentPosition: true,
                    gutter: 20
                });

                setTimeout(() => {
                    msnry.layout();
                }, 100)
                setTimeout(() => {
                    msnry.layout();
                }, 1000)
                setTimeout(() => {
                    msnry.layout();
                }, 10000)
            })
        }
    },

    initDefaultSlider(){
        const sliders = document.querySelectorAll('.slider.splide');
        if (sliders){
            tools.each(sliders, slider => {
                new Splide( slider, {
                    type   : 'slide',
                    perPage: 1,
                    lazyLoad: 'nearby'
                } ).mount();
            })
        }
    },

    initNumberedTextBoxes() {
        const numberedBoxesComponent = document.querySelector('.numbered-boxes-component')
        if (numberedBoxesComponent) {
            const boxes = numberedBoxesComponent.querySelectorAll('ul li')
            const observer = new IntersectionObserver(entries => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        boxes.forEach( (box, index) => {
                            setTimeout(() => {
                                box.classList.add('box-visible')
                            }, index * 200)
                        });
                        observer.unobserve(numberedBoxesComponent)
                    }
                });
            }, {
                rootMargin: '0px 0px -200px 0px'
            });
            observer.observe(numberedBoxesComponent)
        }
    },

    initDownloadAll() {
        const linkListElements = document.querySelectorAll('.link-list')
        linkListElements.forEach((linkListElement) => {
            const downloadAllButton = linkListElement.querySelector('.download-all')
            if (downloadAllButton) {
                const links = linkListElement.querySelectorAll('a.download-entry:not(.download-all-link)');
                if (!links || links.length < 1) {
                    downloadAllButton.remove();
                } else {
                    downloadAllButton.addEventListener('click', async () => {
                        const iconWrapper = downloadAllButton.querySelector('.link-icon')
                        const icon = downloadAllButton.querySelector('svg')
                        iconWrapper.innerHTML = this.getOnlyCSSLoadingButton()
                        const zip = new JSZip();

                        await this.generateZipFromLinkListElement(linkListElement, zip);

                        const content = await zip.generateAsync({type: "blob"});
                        const fileName = downloadAllButton.dataset.name;
                        if (fileName) {
                            saveAs(content, `${fileName}.zip`);
                        } else {
                            saveAs(content, "downloads.zip");
                        }
                        iconWrapper.innerHTML = '';
                        iconWrapper.appendChild(icon);
                    });
                }
            }
        })
    },

    async generateZipFromLinkListElement(linkListElement, zip) {
        const folderName = linkListElement.querySelector(':scope > .download-all').dataset.name
        const folder = zip.folder(folderName);
        const directLiChilds = Array.from(linkListElement.querySelectorAll(':scope > li'))

        const promises = directLiChilds.map(async (liElement) => {
            if (liElement.querySelector(':scope > a.download-entry:not(.download-all-link)')) {
                const linkElement = liElement.querySelector(':scope > a.download-entry:not(.download-all-link)');
                const fileLink = linkElement.href;
                const filename = linkElement.querySelector('.link-title').textContent.trim();

                try {
                    const response = await fetch(fileLink);
                    if (!response.ok) throw new Error('Network error');
                    const blob = await response.blob();
                    folder.file(filename, blob);
                } catch (e) {
                    console.error(`Failed to load ${fileLink}:`, e);
                }
            } else if (liElement.querySelector(':scope > ul.link-list')) {
                const linkListElement = liElement.querySelector(':scope > ul.link-list');
                await this.generateZipFromLinkListElement(linkListElement, folder);
            }
        })

        await Promise.all(promises);

    },

    getOnlyCSSLoadingButton() {
        return '<div class="lds-ring" style="height: 100%; display: flex; justify-content: center; align-items: center; color: black"><div></div><div></div><div></div><div></div></div><style>\n' +
            '.lds-ring,\n' +
            '.lds-ring div {\n' +
            '  box-sizing: border-box;\n' +
            '}\n' +
            '.lds-ring {\n' +
            '  display: inline-block;\n' +
            '  position: relative;\n' +
            '  width: 80px;\n' +
            '  height: 80px;\n' +
            '}\n' +
            '.lds-ring div {\n' +
            '  box-sizing: border-box;\n' +
            '  display: block;\n' +
            '  position: absolute;\n' +
            '  width: 64px;\n' +
            '  height: 64px;\n' +
            '  margin: 8px;\n' +
            '  border: 8px solid currentColor;\n' +
            '  border-radius: 50%;\n' +
            '  animation: lds-ring 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n' +
            '  border-color: currentColor transparent transparent transparent;\n' +
            '}\n' +
            '.lds-ring div:nth-child(1) {\n' +
            '  animation-delay: -0.45s;\n' +
            '}\n' +
            '.lds-ring div:nth-child(2) {\n' +
            '  animation-delay: -0.3s;\n' +
            '}\n' +
            '.lds-ring div:nth-child(3) {\n' +
            '  animation-delay: -0.15s;\n' +
            '}\n' +
            '@keyframes lds-ring {\n' +
            '  0% {\n' +
            '    transform: rotate(0deg);\n' +
            '  }\n' +
            '  100% {\n' +
            '    transform: rotate(360deg);\n' +
            '  }\n' +
            '}\n' +
            '\n</style>'
    },

    initPageFadeOut() {
        const pageTransitionElement = document.querySelector('.page-transition')
        document.querySelectorAll('a').forEach((link) => {
            const href = link.getAttribute('href');

            // Skip if:
            // - href is missing
            // - external link (not starting with '/')
            // - opens in new tab
            // - links to a file like .pdf, .zip, etc.
            if (
                !href ||
                !href.startsWith('/') ||
                link.target === '_blank' ||
                href.match(/\.(pdf|zip|docx?|xlsx?|pptx?|jpg|jpeg|png|gif|mp4|mp3|svg)$/i)
            ) {
                return;
            }
            link.addEventListener('click',(event) => {
                if (
                    event.metaKey
                ) {
                    return;
                }
                const color = pageTransitionElement.dataset.color
                sessionStorage.setItem("color", color )
                pageTransitionElement.classList.forEach(cls => {
                    if (cls.startsWith('bg-')) {
                        pageTransitionElement.classList.remove(cls);
                    }
                });
                pageTransitionElement.classList.add(color)
                pageTransitionElement.style.opacity = '1';
            })
        })
    }
};

document.addEventListener('DOMContentLoaded', () => {
    document.body.classList.add('load-js');
    document.body.classList.remove('no-js');
    app.init();
});
